import { Appointments } from "@/lib/appointments"
import { Businesses } from "@/lib/businesses"
import { Practitioners } from "@/lib/practitioners"
import { Validation } from "@/lib/validation"

export type Registry = {
  AppointmentOffering: Appointments.Offering
  AppointmentResult: Appointments.AppointmentResult
  AppointmentType: Appointments.AppointmentType
  Business: Businesses.Business
  Practitioner: Practitioners.Practitioner
  PractitionerAttributes: Practitioners.PractitionerAttributes
}

export type Model<ModelId extends keyof Registry> =
  Validation.Functions.BuildModelExpectation<Registry, ModelId>

export const Modelling = Validation.setup<Registry>({
  debugEnabled: () => {
    return process.env.NODE_ENV === `development`
  },
  models: () => {
    return {
      AppointmentOffering: Appointments.OfferingModel,
      AppointmentResult: Appointments.AppointmentResultModel,
      AppointmentType: Appointments.AppointmentTypeModel,
      Business: Businesses.BusinessModel,
      Practitioner: Practitioners.PractitionerModel,
      PractitionerAttributes: Practitioners.PractitionerAttributesModel,
    }
  },
})
